import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

let messaging = null;

(() => {
  try {
    messaging = getMessagingInstance();
    console.log("Messaging initialized:", messaging);
  } catch (error) {
    console.error("Error initializing messaging:", error);
  }
})();

export function isMobileDevice(isOnlyApp = false) {
  if (isOnlyApp) {
    return navigator.userAgent.includes("isAppIGS");
  }

  const ua = navigator.userAgent || window.opera;

  const isIOSDevice =
    /iPhone|iPod|iPad/.test(ua) ||
    (/Macintosh|MacIntel/.test(ua) && navigator.maxTouchPoints > 1);

  const isAndroidDevice = /android/i.test(ua);

  const isChromeOS = /CrOS/.test(ua);

  return isIOSDevice || isAndroidDevice || isChromeOS;
}

export function isMobileSafari() {
  const ua = (navigator.userAgent || window.opera).toLowerCase();


  const isSafari =
    ua.includes("safari") &&
    !ua.includes("chrome") &&
    !ua.includes("crios") &&
    !ua.includes("fxios") &&
    !ua.includes("edgios");

   const isIOSDevice =
    /iphone|ipod|ipad/.test(ua) ||
    (/macintosh|macintel/.test(ua) && navigator.maxTouchPoints > 1);

      console.log(isSafari,isIOSDevice, "isMobileSafari");

  return isSafari && isIOSDevice;
}

function getMessagingInstance() {
  if (isMobileDevice()) {
    console.log("Firebase messaging không hỗ trợ trình duyệt này.");
    return null;
  }
  if (!messaging) {
    messaging = getMessaging(app);
  }
  return messaging;
}

export { messaging, getToken, onMessage, deleteToken, isSupported };
